import { __rest } from "tslib";
import * as React from 'react';
import { insertCSSIntoDom } from 'shared/utils';
import AnimatableDiv from './AnimatableDiv';
import { mouseEventProps } from './mouseEventProps';
import { applyAttributeStyles, joinClass } from './symbolUtils';
const attributeStyleMap = {
    backgroundImageStyle: {
        cover: {
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
        },
        contain: {
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
        },
        auto: {
            backgroundSize: 'auto',
            backgroundRepeat: 'no-repeat',
        },
    },
};
export const Image = ({ conditionalState, hoverAnimation, innerRef, inEditor, symbol, timelineRefId, }) => {
    const { clickClass, mouseEventStyles, onClick } = mouseEventProps(symbol, inEditor, hoverAnimation);
    const { attributes, position, styles } = conditionalState;
    const { backgroundImage, backgroundPosition, imageRendering } = styles, otherStyles = __rest(styles, ["backgroundImage", "backgroundPosition", "imageRendering"]);
    const attributeStyles = applyAttributeStyles(attributes, attributeStyleMap);
    const className = joinClass(symbol.id, conditionalState.id, clickClass, 
    // image rendering class
    imageRendering);
    return (React.createElement(AnimatableDiv, { className: className, hoverAnimation: hoverAnimation, id: timelineRefId, innerRef: innerRef, onClick: onClick, position: position, style: Object.assign(Object.assign(Object.assign({}, mouseEventStyles), otherStyles), { display: 'flex', overflow: 'hidden' }), inEditor: inEditor },
        React.createElement("div", { style: Object.assign({ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, backgroundImage: `url(${styles.backgroundImage})`, backgroundPosition: backgroundPosition || 'center' }, attributeStyles) })));
};
export default Image;
// DO NOT USE STYLED-COMPONENT HERE
const imageCSS = `
    .crisp-edges {
        image-rendering: -webkit-optimize-contrast;
        image-rendering: crisp-edges;
    }
    .pixelated {
        image-rendering: pixelated;
    }
    .visually-hidden {
        position: absolute;
        height: 1px;
        width: 1px;
        overflow: hidden;
        clip-path: inset(50%);
        white-space: nowrap;
    }
`;
insertCSSIntoDom(imageCSS, 'image-css');
